import type { AgeFilterOption } from "components/AgeFilter"

export enum ProjectsMoreFiltersKeys {
    RAISED_ON_START = "raised_on_start",
    RAISED_ON_END = "raised_on_end",
    RAISED_ON_OPTION = "raised_on_option",
    RAISED_BY = "raised_by",
    TEMPLATE = "template_id",
    CHARGER_TYPE = "charger_type",
    BUSINESS_POC = "business_poc_ids",
    EXECUTED_BY = "executed_by",
    AGE = "age",
    AGE_OPTION = "age_op",
    CLOSED_ON_START = "closed_on_start",
    CLOSED_ON_END = "closed_on_end",
    CLOSED_ON_OPTION = "closed_on_option",
    TAGS = "tag_ids",
    ACCOUNTS = "account_ids",
    ON_HOLD = "on_hold",
    REQUESTED_CLOSURE_DATE = "requested_closure_date",
    COUNTRY = "country",
    ZONES = "zones",
    STATES = "state_id",
    CITIES = "city_id",
    PROGRAM = "program_ids",
    CATEGORY = "category_ids",
    ACCOUNT_ROLE = "account_type_ids",
    ECOM_ORDER_ID = "ecom_order_id",
    PARENT_ACCOUNT = "parent_account_ids",
    REJECT_TICKETS = "reject_tickets",
}

type DropdownOption = { id: string | number; title: string }

export type ProjectsMoreFiltersType = {
    [ProjectsMoreFiltersKeys.RAISED_ON_START]: string
    [ProjectsMoreFiltersKeys.RAISED_ON_END]: string
    [ProjectsMoreFiltersKeys.RAISED_ON_OPTION]: DropdownOption | null
    [ProjectsMoreFiltersKeys.RAISED_BY]: DropdownOption | null
    [ProjectsMoreFiltersKeys.TEMPLATE]: DropdownOption[]
    [ProjectsMoreFiltersKeys.CHARGER_TYPE]: DropdownOption | null
    [ProjectsMoreFiltersKeys.BUSINESS_POC]: DropdownOption[]
    [ProjectsMoreFiltersKeys.EXECUTED_BY]: DropdownOption | null
    [ProjectsMoreFiltersKeys.AGE]: number[]
    [ProjectsMoreFiltersKeys.AGE_OPTION]: AgeFilterOption | null
    [ProjectsMoreFiltersKeys.CLOSED_ON_START]: string
    [ProjectsMoreFiltersKeys.CLOSED_ON_END]: string
    [ProjectsMoreFiltersKeys.CLOSED_ON_OPTION]: DropdownOption | null
    [ProjectsMoreFiltersKeys.TAGS]: DropdownOption[]
    [ProjectsMoreFiltersKeys.ACCOUNTS]: DropdownOption[]
    [ProjectsMoreFiltersKeys.ON_HOLD]: DropdownOption | null
    [ProjectsMoreFiltersKeys.REQUESTED_CLOSURE_DATE]: string
    [ProjectsMoreFiltersKeys.COUNTRY]: DropdownOption | null
    [ProjectsMoreFiltersKeys.ZONES]: DropdownOption[]
    [ProjectsMoreFiltersKeys.STATES]: DropdownOption[]
    [ProjectsMoreFiltersKeys.CITIES]: DropdownOption[]
    [ProjectsMoreFiltersKeys.PROGRAM]: DropdownOption[]
    [ProjectsMoreFiltersKeys.CATEGORY]: DropdownOption[]
    [ProjectsMoreFiltersKeys.ACCOUNT_ROLE]: DropdownOption[]
    [ProjectsMoreFiltersKeys.ECOM_ORDER_ID]: DropdownOption | null
    [ProjectsMoreFiltersKeys.PARENT_ACCOUNT]: DropdownOption[]
    [ProjectsMoreFiltersKeys.REJECT_TICKETS]: boolean
}

export const INITIAL_MORE_FILTERS: ProjectsMoreFiltersType = {
    [ProjectsMoreFiltersKeys.RAISED_ON_START]: "",
    [ProjectsMoreFiltersKeys.RAISED_ON_END]: "",
    [ProjectsMoreFiltersKeys.RAISED_ON_OPTION]: null,
    [ProjectsMoreFiltersKeys.RAISED_BY]: null,
    [ProjectsMoreFiltersKeys.TEMPLATE]: [],
    [ProjectsMoreFiltersKeys.CHARGER_TYPE]: null,
    [ProjectsMoreFiltersKeys.BUSINESS_POC]: [],
    [ProjectsMoreFiltersKeys.EXECUTED_BY]: null,
    [ProjectsMoreFiltersKeys.AGE]: [],
    [ProjectsMoreFiltersKeys.AGE_OPTION]: null,
    [ProjectsMoreFiltersKeys.CLOSED_ON_START]: "",
    [ProjectsMoreFiltersKeys.CLOSED_ON_END]: "",
    [ProjectsMoreFiltersKeys.CLOSED_ON_OPTION]: null,
    [ProjectsMoreFiltersKeys.TAGS]: [],
    [ProjectsMoreFiltersKeys.ACCOUNTS]: [],
    [ProjectsMoreFiltersKeys.ON_HOLD]: null,
    [ProjectsMoreFiltersKeys.REQUESTED_CLOSURE_DATE]: "",
    [ProjectsMoreFiltersKeys.COUNTRY]: null,
    [ProjectsMoreFiltersKeys.ZONES]: [],
    [ProjectsMoreFiltersKeys.STATES]: [],
    [ProjectsMoreFiltersKeys.CITIES]: [],
    [ProjectsMoreFiltersKeys.PROGRAM]: [],
    [ProjectsMoreFiltersKeys.CATEGORY]: [],
    [ProjectsMoreFiltersKeys.ACCOUNT_ROLE]: [],
    [ProjectsMoreFiltersKeys.ECOM_ORDER_ID]: null,
    [ProjectsMoreFiltersKeys.PARENT_ACCOUNT]: [],
    [ProjectsMoreFiltersKeys.REJECT_TICKETS]: false,
}
